import React from "react";
import { ArrowUp } from "lucide-react";
import { useLang } from "@/i18n";

const scrollToTop = () => {
  if (typeof window === "undefined") return;
  // `prefers-reduced-motion` respects the user's OS-level accessibility
  // preference; fall back to instant jump when motion is suppressed.
  const reduced =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  window.scrollTo({ top: 0, behavior: reduced ? "auto" : "smooth" });
};

const BottomPageNav = () => {
  const { t } = useLang();

  // DASHBOARD-SIDEMENU-PROFILES-1-FIX3 — `back to menu` button retired
  // because the persistent side menu now provides a `Panel` entry that
  // works as the universal return point from any screen. Only the
  // "scroll to top" affordance remains here.
  return (
    <div
      className="mt-12 pt-6 border-t border-slate-200 flex flex-col sm:flex-row gap-3 sm:gap-4 sm:justify-end"
      data-testid="bottom-page-nav"
    >
      <button
        type="button"
        onClick={scrollToTop}
        className="tsw-btn-primary"
        data-testid="bottom-back-to-top"
      >
        <ArrowUp className="w-4 h-4" /> {t("nav.backToTop")}
      </button>
    </div>
  );
};

export default BottomPageNav;
